import React from 'react'
import styled from '@emotion/styled'
import './style.css'

const Soon = props => (
    <div data-aos="flip-down" className="soon">
        <p class="sentence">หนี Covid มา
            <div class="slidingVertical">
                <span><strong>จ้างงาน</strong></span>
                <span><strong>หาเงิน</strong></span>
                <span><strong>หาเรา</strong></span>
            </div>
            <div className="lastHide">
                <span> &nbsp;&nbsp; &nbsp;  &nbsp;  &nbsp; กับเรา... </span>
            </div>
            &nbsp;  &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; เร็ว ๆ นี้
        </p>
    </div>
)

export default Soon